import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  html {\n    color: ", ";\n    font-family: ", ";\n  }\n\n  // Works around a CSS Reset inheritance issue in @chegg-ui/header. Ideally this would be in that component, but this allows for it to be backward-compatible.\n  [data-test=\"header-root-nav\"] * {\n    box-sizing: border-box;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import * as React from 'react';
import { createGlobalStyle } from 'styled-components';
import colors from '../colors';
import CSSReset from '../CSSReset';
import fontFamily from '../fontFamily';
import { WebfontLoader } from '../WebfontLoader';
var GlobalStyles = createGlobalStyle(_templateObject(), colors.dark, fontFamily["default"]);

var CSSBaseline = function CSSBaseline() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(WebfontLoader, null), /*#__PURE__*/React.createElement(CSSReset, null), /*#__PURE__*/React.createElement(GlobalStyles, null));
};
/**
 * @deprecated Start using CSSBaseline. This will be removed in future versions
 */


export var FantaCSSBaseline = CSSBaseline;
export default CSSBaseline;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/CSSBaseline/index.js
// module id = 1780
// module chunks = 12